<template>
  <div class="custom-control custom-switch d-flex" :class="{ 'pl-0 justify-content-between': !!label }">
    <div v-if="label" class="font-weight-light mb-1 side-box__content__label mr-5 pr-1">
      {{ label }}
    </div>
    <input
      :id="fieldId ? fieldId : 'iidd'"
      type="checkbox"
      class="custom-control-input"
      :checked="value"
      :disabled="disabled"
      @click="switchValue()"
    />
    <label
      class="custom-control-label"
      :title="disabled ? this.$t('CHECKBOX_DISABLED') : ''"
      :class="disabled ? 'disabled' : ''"
      :for="fieldId ? fieldId : 'iidd'"
    />
    <span v-if="text" :class="{ 'ml-2': !label }">
      <span v-if="value" :class="{ 'ml-1': !label }" class="text-success">{{ $t("zapnuto") }}</span>
      <span v-else :class="{ 'ml-1': !label }">{{ $t("vypnuto") }}</span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    fieldId: String,
    value: Boolean,
    disabled: Boolean,
    text: Boolean,
    label: String
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    switchValue() {
      this.$emit("switch")
    }
  }
}
</script>

<style lang="scss" scoped></style>
